import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import { Box } from '../../../../../../../../../../CommonComponents/OPL/Box/Box';
import { Select } from '../../../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { Button } from '../../../../../../../../../../CommonComponents/OPL/Button/Button';
import { useClientListQuery } from './api/useClientListQuery';
import { useMoveAccountMutation } from './api/useMoveAccountMutation';
import { useAccountFormContext } from '../../../../context/useAccountFormContext';
import { ACCOUNTS_QUERY_KEY } from '../../../../../../../../AccountsConstants';
import { ACCOUNT_PREFERENCES_QUERY_KEY } from '../../../../../../../../api/useAccountsQuery';
import { toast } from '../../../../../../../../../../CommonComponents/OPL/Toast/Toast';
import { MESSAGES } from '../../../../../../../../../../CommonConstants';
import { useClientId } from '../../../../../../../../../../_hooks/useClientId';

export const MoveAccount = () => {
  const { onClose, accountId } = useAccountFormContext();

  const queryClient = useQueryClient();

  const [selectedClient, setSelectedClient] = useState<{ value: number; label: string } | null>(
    null,
  );

  const clientId = useClientId();

  const { isLoading: isLoadingClientList, data: clientList } = useClientListQuery();

  const { mutateAsync: moveAccount, isLoading: isMovingAccount } = useMoveAccountMutation();

  const handleMoveAccount = async () => {
    if (!selectedClient || !accountId) {
      return;
    }

    try {
      await moveAccount({
        accountId,
        toConsumerId: selectedClient.value,
      });

      onClose();

      queryClient.invalidateQueries([ACCOUNTS_QUERY_KEY, ACCOUNT_PREFERENCES_QUERY_KEY, clientId]);
    } catch (error) {
      console.error(error);
      toast.error(MESSAGES.GENERIC_ERROR);
    }
  };

  const options = (clientList || [])
    .filter(client => client.Id !== clientId)
    .map(({ Id, FirstName, LastName }) => ({
      value: Id,
      label: `${FirstName} ${LastName}`,
    }));

  return (
    <Box display="flex" alignItems="flex-end" style={{ gap: 16 }}>
      <Box width={380}>
        <Select
          isLoading={isLoadingClientList}
          placeholder="Select Client"
          label="Select a client to move this account to"
          value={selectedClient}
          options={options}
          onChange={opt => setSelectedClient(opt)}
          isPortal
        />
      </Box>

      <Button
        variant="secondary"
        onClick={handleMoveAccount}
        isLoading={isMovingAccount}
        disabled={!selectedClient}
      >
        Move Account
      </Button>
    </Box>
  );
};
